import React, { Component } from "react";
class OptionSelect extends React.Component
{
    
    constructor(props)
    {
        super(props);
        this.state =
        {
            value: this.props.value,
            liste: [],
        }
    }

    componentDidMount()
    {
    }

    componentDidUpdate()
    {
        if (this.props.onChange) this.props.onChange();
    }


    getValue()
    {
        return this.state.value;
    }

    setValue(value)
    {
        this.setState({value:value})
    }

    render()
    {



        return (<>

            
            <select className="dialog-Input-Datas" 
                id={"select"+this.props.selectname} 
                style = {{width: this.props.width, textAlign: "left"}}
                disabled={this.props.disabled}
                value = {this.state.value}
                onChange={e => this.setState({value:e.target.value})}
                >

                {this.props.liste.map((oneoption, index) => 
                
                    
                    (

                    <option key={index} value={index}>
                     {oneoption}

                    </option>
                    ))}


            </select>


            
        </>);
    
    }

}
OptionSelect.defaultProps = 
{
    autoFocus: false,
    readOnly: false,
    disabled: false,
}

export default OptionSelect